module.exports = __webpack_public_path__ + "img/25.cc2cfd62.jpg";